import { makeStyles } from 'tss-react/mui';

const name = 'Header';

export const useHeaderStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(7.5),

    padding: theme.spacing(7.5),

    borderRadius: theme.shape.borderRadiusLg,

    backgroundColor: theme.palette.background.paper,
  },
  chainOverview: {
    display: 'flex',
    justifyContent: 'space-between',

    marginBottom: theme.spacing(7.5),
  },
  left: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  logo: {
    width: theme.spacing(17),
    height: theme.spacing(17),
  },
  description: {
    margin: 0,
  },
  title: {
    width: theme.spacing(43),
    height: theme.spacing(10),
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadiusMd,
  },
  subtitle: {
    width: theme.spacing(31.5),
    height: theme.spacing(6),
    borderRadius: theme.shape.borderRadiusMd,
  },
  docs: {
    width: theme.spacing(20),
    height: theme.spacing(8),
    borderRadius: theme.shape.borderRadiusMd,
  },
  controls: {
    display: 'flex',
    gap: theme.spacing(3),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  chainTypeSelector: {
    width: theme.spacing(77),
    height: theme.spacing(10),
    borderRadius: theme.shape.borderRadiusMd,

    [theme.breakpoints.down('md')]: {
      width: theme.spacing(76),
      height: theme.spacing(8),
    },
  },
  groupSelector: {
    width: theme.spacing(117.5),
    height: theme.spacing(10),
    borderRadius: theme.shape.borderRadiusMd,

    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: theme.spacing(10),
    },
  },
}));
